import React, { Component } from 'react'

import config from 'config'
import styles from './email-tag-input.css'
import TagInput from '../tag-input/tag-input'
import PropTypes from 'prop-types'

const NOT_EMPTY_MESSAGE = 'Dies ist ein Pflichtfeld'

class EmailTagInput extends Component {
  constructor(props) {
    super(props)

    const { emails } = props

    this.state = {
      emails,
      isInvalid: false,
      errorMessage: '',
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(tags) {
    const { name, required, onChange } = this.props

    let errorMessage
    const isInvalid = required && !tags.length
    if (required && !tags.length) {
      errorMessage = NOT_EMPTY_MESSAGE
    }

    const filteredEmails = tags.filter(tag => {
      return config.emailCheck.test(tag)
    })

    this.setState({ emails: filteredEmails, isInvalid, errorMessage }, () => {
      onChange && onChange(filteredEmails, name)
    })
  }

  render() {
    const { name, label, dataQsId } = this.props
    const { emails, isInvalid, errorMessage } = this.state

    const labelEl = label
      ? <label className={styles.label}>{label}</label>
      : null
    const error = isInvalid
      ? <div className={styles.error}>{errorMessage}</div>
      : null
    const tagsClass = `${styles.tags} ${isInvalid ? styles.invalid : ''}`

    return (
      <div className={styles.container} data-qs-id={dataQsId}>
        {labelEl}
        <TagInput
          name={name}
          tags={emails}
          classNames={{
            tag: styles.tag,
            tags: tagsClass,
            tagInput: styles.tagInput,
            tagInputField: styles.tagInputField,
            focused: styles.focused,
            remove: styles.remove,
          }}
          onChange={this.handleChange}
          onBlur={this.handleChange} />
        {error}
      </div>
    )
  }
}

EmailTagInput.propTypes = {
  emails: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

EmailTagInput.defaultProps = {
  required: false,
  emails: [],
}

export default EmailTagInput
